export const SECOND = 1000;
export const HALF_SECOND = SECOND / 2;
export const QUARTER_SECOND = SECOND / 4;

export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_DAY = SECONDS_IN_MINUTE * MINUTES_IN_HOUR * 24;
